'use es6';

import { Record } from 'immutable'; // For API calls that go to FB that look like:
// {adid}/insights?breakdowns=publisher_platform,impression_device&fields=......

export default Record({
  publisherPlatform: null,
  impressionDevice: null,
  dateStart: null,
  dateStop: null,
  ctr: null,
  cpc: null,
  clicks: null,
  impressions: null,
  cost: null,
  reach: null
});